import { h, Host } from "@stencil/core";
let id = 0;
export class CoreToggle {
    constructor() {
        this.toggleId = `toggle-${++id}`;
        this.handleToggle = () => {
            if (this.disabled)
                return;
            this.selected = !this.selected;
            this.coreToggleChange.emit(this.selected);
        };
        this.handleKeyDown = (event) => {
            if (this.disabled)
                return;
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.handleToggle();
            }
        };
        this.renderLabel = () => {
            return (h("label", { class: "toggle-label typography-body-medium-regular", id: `${this.toggleId}-label`, onClick: this.handleToggle }, this.label));
        };
        this.renderDescription = () => {
            return h("span", { class: "toggle-description typography-body-small-regular" }, this.description);
        };
        this.renderInfos = () => {
            return (h("div", { class: "infos-box" }, this.renderLabel(), this.description && this.renderDescription()));
        };
        this.label = undefined;
        this.description = undefined;
        this.format = 'right';
        this.selected = false;
        this.disabled = false;
    }
    valueChanged(newValue, oldValue) {
        if (newValue !== oldValue) {
            this.selected = newValue;
        }
    }
    render() {
        return (h(Host, { key: '99c4633ff0c6e55b0f6eec99defeefb81c3e93ca' }, h("div", { key: '9bf5bcbbb4960e9735d573107f584e7fae287d22', class: `core-toggle ${this.disabled ? 'toggle--disabled' : ''} ${this.selected ? 'toggle--selected' : ''}` }, this.format === 'left' && this.renderInfos(), h("div", { key: 'a772eb4b93fcb18e941c79e2c382f29cf59c8727', class: "toggle-wrapper" }, h("button", { key: 'f3007c3833dd13cc869884b67276ac34694b6e19', role: "switch", class: "toggle-box", onKeyDown: event => {
                this.handleKeyDown(event);
            }, onClick: event => {
                event.preventDefault();
                this.handleToggle();
            }, "aria-label": this.format === 'hidden' ? this.label : null, "aria-labelledby": `${this.toggleId}-label`, "aria-checked": this.selected, disabled: this.disabled, "aria-disabled": this.disabled }, h("span", { key: '227bd57157b14a3d4d3a92a4c435c87d8149ba65', class: "toggle-background", "aria-hidden": "true" }), h("span", { key: '321c80cb80309725337174f3c82976345e549486', class: "toggle-inner" }, h("span", { key: 'a37e24d3080175bf66200f245affd5151613d5ad', class: "option option--true", "aria-label": "active" }), h("span", { key: 'cdf7055da3478b96c70cf324ed2ff57ab77b3e55', class: "option option--false", "aria-label": "disactive" }), h("span", { key: '7d41d27f1832905b6d0dc01e40480aa529d82bd7', class: "toggle-handle", "aria-hidden": "true" }, this.selected && (h("svg", { width: "1rem", height: "1rem", fill: "var(--color-selection-primary-background-selected)", xmlns: "http://www.w3.org/2000/svg" }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.2313 3.84178C12.6872 4.15365 12.8038 4.77597 12.492 5.23177L8.15864 11.5651C7.98545 11.8182 7.70568 11.9779 7.39966 11.9982C7.09364 12.0186 6.7952 11.8974 6.59003 11.6694L3.59003 8.33605C3.22058 7.92554 3.25385 7.29325 3.66436 6.92379C4.07487 6.55433 4.70716 6.58761 5.07662 6.99812L7.22602 9.38635L10.8414 4.1024C11.1532 3.6466 11.7755 3.52991 12.2313 3.84178Z" }))))))), this.format === 'right' && this.renderInfos())));
    }
    static get is() { return "core-toggle"; }
    static get originalStyleUrls() {
        return {
            "$": ["core-toggle.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["core-toggle.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label that accompany the toggle. It is **required** for accessibility concerns."
                },
                "attribute": "label",
                "reflect": true
            },
            "description": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Description will append below the label."
                },
                "attribute": "description",
                "reflect": false
            },
            "format": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "'right' | 'left' | 'hidden'",
                    "resolved": "\"hidden\" | \"left\" | \"right\"",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "A string indicating the position of the label or if it is hidden."
                },
                "attribute": "format",
                "reflect": false,
                "defaultValue": "'right'"
            },
            "selected": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "A Boolean indicating whether the toggle is selected or not.\n\nIt should be false if the toggle is `indeterminate`."
                },
                "attribute": "selected",
                "reflect": true,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "A boolean indicating the disable state of the Toggle. The `aria-disabled` attribute relies on this property."
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "coreToggleChange",
                "name": "coreToggleChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                }
            }];
    }
    static get watchers() {
        return [{
                "propName": "selected",
                "methodName": "valueChanged"
            }];
    }
}
//# sourceMappingURL=core-toggle.js.map
